import { render, staticRenderFns } from "./55ygckcsjsfwjz.vue?vue&type=template&id=58389710&"
import script from "./55ygckcsjsfwjz.vue?vue&type=script&lang=js&"
export * from "./55ygckcsjsfwjz.vue?vue&type=script&lang=js&"
import style0 from "./55ygckcsjsfwjz.vue?vue&type=style&index=0&id=58389710&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports